import { Component, PropTypes } from 'react';
import cx from 'classnames';
import _ from 'lodash';
import { names, messagesBySection } from 'config';
import styles from './styles.css';

export default class Participants extends Component {
	static propTypes = {
		onParticipantClick: PropTypes.func.isRequired,
		activeAside: PropTypes.object
	}

	getAside(name) {
		return _.find(messagesBySection[0], (message) => {
			return message.name === name
				&& message.aside;
		}).aside;
	}

	render() {
		return (
			<div className={styles.participants}>
				<div className={styles.label}>Participants</div>

				{Object.keys(names).map((key, index) => {
					const aside = this.getAside(names[key]);

					const className = cx(styles.participant, {
						[styles.active]: this.props.activeAside === aside
					});

					return (
						<div key={index} className={className} onClick={() => this.props.onParticipantClick(aside)}>
							{names[key]}
						</div>
					);
				})}
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./components/Participants/index.js
 **/